import { Steps } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';

type StepKey = 'configuration' | 'content' | 'schedule';

interface BannerStepperProps {
  currentStep: number;
  onChangeStep: (value: number) => void;
  stepsCompleted: Record<StepKey, boolean>;
  stepsWithErrors: Record<StepKey, boolean>;
}

const STEP_KEYS: StepKey[] = ['configuration', 'content', 'schedule'];

const steps = [
  { title: 'Estrutura', subTitle: 'Dispositivo, segmentação, slot' },
  { title: 'Conteúdo', subTitle: 'Imagens e destinos' },
  { title: 'Agendamento', subTitle: 'Publicação imediata ou programada' },
];

export const BannerStepper: FC<BannerStepperProps> = ({
  currentStep,
  onChangeStep,
  stepsCompleted,
  stepsWithErrors,
}) => {
  const getStepStatus = (index: number) => {
    const key = STEP_KEYS[index];
    if (currentStep === index) return 'process';
    if (stepsCompleted[key]) return 'finish';
    if (stepsWithErrors[key]) return 'error';
    return 'wait';
  };

  return (
    <StyledSteps
      type='navigation'
      current={currentStep}
      onChange={onChangeStep}
      labelPlacement='horizontal'
      size='default'
      items={steps.map((step, index) => ({
        title: step.title,
        subTitle: step.subTitle,
        status: getStepStatus(index),
      }))}
    />
  );
};

export const StyledSteps = styled(Steps)`
  margin-bottom: 40px;
  box-shadow: 0px -1px 0 0 #383838 inset;

  .ant-steps-item-title {
    font-size: 16px;
    font-weight: 600;
  }

  .ant-steps-item-subtitle {
    font-size: 12px;
    opacity: 0.7;
  }

  .ant-steps-item-wait .ant-steps-item-title {
    color: rgba(255, 255, 255, 0.45);
  }

  .ant-steps-item-process .ant-steps-item-icon {
    background-color: #1890ff;
    border-color: #1890ff;
  }
`;
